import { getBackendApiUrl } from "../baseUrl";
import { AxiosError, AxiosRequestConfig } from "axios";
import { ResponseError } from "../types/errors";

type APIDomain = "users";

export function buildApiConfig(
  domain: APIDomain,
  accessToken: string
): AxiosRequestConfig {
  return {
    baseURL: `${getBackendApiUrl()}/${domain}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
}
